"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("../actions");

var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));

var _carouselControls = _interopRequireDefault(require("./carousel-controls"));

var _carouselImagesContainer = _interopRequireDefault(require("./carousel-images-container"));

var _carouselImages2 = _interopRequireDefault(require("./carousel-images.props/carousel-images.defaultProps"));

var _carouselImages3 = _interopRequireDefault(require("./carousel-images.props/carousel-images.propTypes"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * ## CarouselImages - component
 *
 * This is a carousel component that displays one image at a time
 */
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    handleNestedProp = dataUtils.handleNestedProp,
    formatAsMKSPath = dataUtils.formatAsMKSPath;
var twoSlidesCarousel = 2;

var shouldDoubleSlides = function shouldDoubleSlides(slides) {
  if (slides && slides.length === 2) {
    return [].concat(slides, slides);
  }

  return slides;
};

var calculateUpdatedVisibleImageIndex = function calculateUpdatedVisibleImageIndex(direction, visibleImageIndex, carouselImagesLength) {
  var currentVisibleImageIndex = visibleImageIndex || 0;
  currentVisibleImageIndex += direction;
  currentVisibleImageIndex %= carouselImagesLength;
  if (currentVisibleImageIndex < 0) currentVisibleImageIndex = carouselImagesLength - 1;
  return currentVisibleImageIndex;
};

var CarouselImages = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CarouselImages, _React$Component);

  // All components need a resourceType in order for AEM to be aware of its existance
  CarouselImages.resourceType = function resourceType() {
    return 'CarouselImage_1_0_0';
  };

  function CarouselImages(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      visibleImageIndex: 0,
      carouselImagesLength: 0,
      sliding: false,
      direction: 1,
      swipeThreshold: {
        x: 100,
        y: 100
      },
      origin: {
        x: 0,
        y: 0
      },
      previous: {
        x: 0,
        y: 0
      },
      cancelTouch: false,
      items: [],
      slidesDoubled: false,
      textBoxSizes: []
    };
    _this.handleSlide = _this.handleSlide.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getOrder = _this.getOrder.bind((0, _assertThisInitialized2["default"])(_this));
    _this.doSliding = _this.doSliding.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchMove = _this.handleTouchMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTouchEnd = _this.handleTouchEnd.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateItemsLengthState = _this.updateItemsLengthState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateTextBoxSizes = _this.updateTextBoxSizes.bind((0, _assertThisInitialized2["default"])(_this));
    var dispatch = props.dispatch,
        data = props.data,
        position = props.position,
        market = props.market;
    var activeSlide = data.items && data.items[0];
    var imagePath = activeSlide && activeSlide.image.image;

    if (activeSlide && market.toLowerCase() === 'mx' && imagePath) {
      dispatch((0, _actions.addPromo)({
        locationId: position,
        promotionId: imagePath,
        promotionName: handleNestedProp(activeSlide, 'activeSlide.image.altText')
      }));
    }

    return _this;
  }

  var _proto = CarouselImages.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        data = _this$props.data,
        defaultData = _this$props.defaultData;
    var stateItems = this.state.items;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var items = componentData.items;
    if (items && items.length === 2) this.setState({
      slidesDoubled: true
    });
    this.publishSlideView(0);
    return items !== stateItems && this.updateItemsLengthState(shouldDoubleSlides(items));
  };

  _proto.handleSlide = function handleSlide(visibleImageIndex, carouselImagesLength, direction) {
    if (carouselImagesLength === twoSlidesCarousel && visibleImageIndex === 0) {
      return;
    }

    var updatedVisibleImageIndex = calculateUpdatedVisibleImageIndex(direction, visibleImageIndex, carouselImagesLength);
    this.doSliding(direction, updatedVisibleImageIndex);
    this.publishSlideView(updatedVisibleImageIndex);
  };

  _proto.handleTouchStart = function handleTouchStart(e) {
    e.persist();

    if (e && e.touches.length === 1) {
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          origin: {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          },
          previous: {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          }
        });
      });
    }
  };

  _proto.handleTouchMove = function handleTouchMove(e) {
    var _this$state = this.state,
        origin = _this$state.origin,
        cancelTouch = _this$state.cancelTouch,
        swipeThreshold = _this$state.swipeThreshold,
        visibleImageIndex = _this$state.visibleImageIndex,
        carouselImagesLength = _this$state.carouselImagesLength;

    if (!e) {
      return;
    }

    e.persist();

    if (e.touches.length === 1 && cancelTouch !== true) {
      var swipeDistance = {
        x: origin.x - e.changedTouches[0].pageX,
        y: origin.y - e.changedTouches[0].pageY
      };
      this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          previous: {
            x: e.changedTouches[0].pageX,
            y: e.changedTouches[0].pageY
          }
        });
      }); // if a true swipe has occured

      if (Math.abs(swipeDistance.x) > swipeThreshold.x) {
        // is it a forward or previous swipe
        var direction = Math.sign(swipeDistance.x); // TODO: if direction is RTL this will be the opposite

        this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            origin: {
              x: e.changedTouches[0].pageX,
              y: e.changedTouches[0].pageY
            },
            direction: direction,
            cancelTouch: true
          });
        });
        this.handleSlide(visibleImageIndex, carouselImagesLength, direction);
      }
    }
  };

  _proto.handleTouchEnd = function handleTouchEnd() {
    this.setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        cancelTouch: false
      });
    });
  };

  _proto.getOrder = function getOrder(itemIndex) {
    var _this$state2 = this.state,
        visibleImageIndex = _this$state2.visibleImageIndex,
        carouselImagesLength = _this$state2.carouselImagesLength; // if index is past the end and should wrap around to front of array return desired order

    if (itemIndex - visibleImageIndex < 0) {
      return carouselImagesLength - Math.abs(itemIndex - visibleImageIndex);
    } // if there's just two slides they just go back and forth


    if (carouselImagesLength === twoSlidesCarousel) return itemIndex;
    return itemIndex - visibleImageIndex;
  };

  _proto.updateTextBoxSizes = function updateTextBoxSizes(value) {
    var textBoxSizes = this.state.textBoxSizes;

    if (textBoxSizes.indexOf(value) === -1) {
      this.setState(function (state) {
        return {
          textBoxSizes: [].concat(state.textBoxSizes, [value])
        };
      });
    }
  };

  _proto.doSliding = function doSliding(direction, visibleImageIndex) {
    var _this2 = this;

    this.setState({
      sliding: true,
      direction: direction,
      visibleImageIndex: visibleImageIndex
    }); // eslint-disable-next-line no-undef

    setTimeout(function () {
      _this2.setState({
        sliding: false
      });
    }, 50); // eslint-disable-line no-magic-numbers
  };

  _proto.updateItemsLengthState = function updateItemsLengthState(items) {
    return this.setState({
      carouselImagesLength: items && items.length ? items.length : 0,
      direction: items && items.length === 2 ? -1 : 1 // eslint-disable-line no-magic-numbers

    });
  };

  _proto.publishSlideView = function publishSlideView(activeSlideIndex) {
    var _this$props2 = this.props,
        currentPath = _this$props2.currentPath,
        market = _this$props2.market,
        items = _this$props2.data.items,
        position = _this$props2.position,
        dispatch = _this$props2.dispatch;
    var activeSlide = items[activeSlideIndex] || items[activeSlideIndex - items.length];
    var imagePath = handleNestedProp(activeSlide, 'activeSlide.image.image');

    if (market.toLowerCase() === 'mx' && typeof window !== 'undefined' && window.dataLayer) {
      var promotionName = handleNestedProp(activeSlide, 'activeSlide.image.altText');
      window.dataLayer.push({
        event: 'view_banner',
        view_bannerdata: [{
          position: 'Body',
          banner_name: promotionName,
          banner_position: activeSlideIndex,
          banner_image_url: imagePath,
          layer: formatAsMKSPath(currentPath)
        }]
      });
      dispatch((0, _actions.updatePromo)(position, activeSlideIndex, imagePath, promotionName));
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state3 = this.state,
        visibleImageIndex = _this$state3.visibleImageIndex,
        carouselImagesLength = _this$state3.carouselImagesLength,
        sliding = _this$state3.sliding,
        direction = _this$state3.direction,
        textBoxSizes = _this$state3.textBoxSizes,
        slidesDoubled = _this$state3.slidesDoubled;
    var _this$props3 = this.props,
        theme = _this$props3.theme,
        data = _this$props3.data,
        defaultData = _this$props3.defaultData; // first we select the data from the larger query coming through

    var componentData = shouldUseDataOrDefaultProps(data, defaultData); // destructure items off data that the component needs

    var items = componentData.items;

    var renderCarouselControls = function renderCarouselControls(cName) {
      var className = "carouselControls_" + cName;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _carouselImages["default"][className]
      }, /*#__PURE__*/_react["default"].createElement(_carouselControls["default"] // eslint-disable-next-line react/jsx-handler-names
      , {
        textBoxSizes: textBoxSizes,
        handleSlide: _this3.handleSlide,
        visibleImageIndex: visibleImageIndex,
        carouselImagesLength: carouselImagesLength,
        theme: theme,
        slidesDoubled: slidesDoubled
      }));
    };

    return /*#__PURE__*/_react["default"].createElement("section", {
      className: theme['container-fluid'] + " " + _carouselImages["default"].carousel + " " + theme['col-sm-12'],
      automation: "CarouselImages",
      onTouchStart: function onTouchStart(e) {
        return _this3.handleTouchStart(e);
      },
      onTouchMove: function onTouchMove(e) {
        return _this3.handleTouchMove(e);
      },
      onTouchEnd: function onTouchEnd() {
        return _this3.handleTouchEnd();
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      role: "region",
      "aria-label": "carousel",
      className: _carouselImages["default"].carouselWrapper + " " + theme['col-sm-offset-1']
    }, /*#__PURE__*/_react["default"].createElement(_carouselImagesContainer["default"], {
      items: shouldDoubleSlides(items),
      visibleImageIndex: visibleImageIndex,
      getOrder: this.getOrder,
      sliding: sliding,
      direction: direction,
      carouselImagesLength: carouselImagesLength,
      twoSlidesCarousel: twoSlidesCarousel,
      theme: theme,
      updateTextBoxSizes: this.updateTextBoxSizes,
      controls: renderCarouselControls,
      handleSlide: this.handleSlide
    })));
  };

  return CarouselImages;
}(_react["default"].Component);

CarouselImages.displayName = 'CarouselImages';
CarouselImages.defaultProps = {
  data: _carouselImages2["default"],
  defaultData: _carouselImages2["default"],
  theme: {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    market: state.Config.market
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(CarouselImages);

exports["default"] = _default;